module.exports = __webpack_public_path__ + "static/q3_o-7db9a7fdef130a60e9e86604d96d86ca.png";